<template>

  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu">
      <div style="height: 60px;background-color: transparent;float: left; margin-left: 20px; display: flex;flex-direction: row;justify-content: start;" @click="goHome()">
        <img  :src="logo"  style="float: left;width: 50px;height: 50px;margin-top: 5px;"/>
        <div style="background-color: transparent; color: white; height: 60px; display: flex;flex-direction: column;justify-content: start; padding-left: 10px;">
          <div class="BSD_TITLE">Global Change Risk Map Platform</div>
          <div class="BSD_SUBTITLE">of Population and Economic Systems</div>
        </div>
      </div>
    </el-header>


    <el-main id="router_view"   class="rt_bg" style="width: 100%;height: 500px;text-align: center; font-family: 'PingFangSC-Medium'">

      <img src="http://bunjs.aiside.top/img_logged.png" style="width: 50vw;z-index: 10;left: 4.8vw;position: absolute;"/>
      <div style="background-color: white;position: absolute;width: 50vw;right: 0px;top: 0px;z-index: 11;height: 100vh;"></div>

      <el-row  style="z-index: 100;
                      background-color: transparent;width: 44vw;margin-left: 28vw;
                      margin-top: 10vh; border-radius: 50px;
                      background-color: rgba(255,255,255,0.9);">
        <el-col :span=12 style="padding: 20px 0px;">
          <img src="../../assets/bnu/login_left.png" style="margin-top: 40px;">
          <p style="color: #324157;font-size: 14px;line-height: 20px; font-family:'PingFangSC-Regular'">
            Global Change Risk Map Platform <br/>
            of Population and Economic Systems
          </p>
        </el-col>

        <el-col :span=12 style="padding: 20px 40px;height: auto; background-color: white; box-shadow: 0 30px 40px 20px rgba(0,0,0,0.05);
          border-radius: 0 50px 50px 0;
          border-radius: 0px 50px 50px 0px;">

          <el-row style="background-color: transparent;">
            <p style="height: 30px;line-height: 30px;font-size: 20px; font-weight: bold; font-family: 'Microsoft YaHei'">Register</p>
          </el-row>

          <br/><br/><br/><br/>
<!--          <el-row style="margin-top: 10px;">-->
<!--            <p style="text-align: left; color:  #128FDC;">Email</p>-->
<!--          </el-row>-->


          <!--            获取验证码-->
          <div v-if="registerIndex==0">
            <el-row style="margin-top: 20px;">
              <el-input placeholder="Email" v-model="registerParam.mail"></el-input>
            </el-row>
            <br/><br/>
            <el-row style="margin-top: 25px;">
              <el-button type="primary" style="width: 100%; font-size: 17px;" @click="getMailVerifyCode">Get Mail Verification Code</el-button>
            </el-row>
          </div>

          <!--            正式注册-->
          <div v-if="registerIndex==1">
            <el-row style="margin-top: 20px;">
              <el-input placeholder="Mail Verification Code"  v-model="registerParam.verifyCode"></el-input>
            </el-row>

            <el-row style="margin-top: 20px;">
              <el-input placeholder="Passwrod"  v-model="registerParam.password" show-password></el-input>
            </el-row>

            <el-row style="margin-top: 20px;">
              <el-input placeholder="Confirm Passwrod"  v-model="registerParam.confirm_password" show-password></el-input>
            </el-row>

            <el-row style="margin-top: 25px;">
              <el-button type="primary" style="width: 100%; font-size: 17px;" @click="submitRegisterRequest">Sumbit</el-button>
            </el-row>
          </div> </div>

          <br/> <br/> <br/> <br/>


          <el-divider></el-divider>

          <el-row style="text-align: center;padding: 15px 0px;font-size: 14px;">
            <a href="/#/BNUMap/Login  " style="color:deepskyblue;font-weight: bold; font-family: ' PingFangSC-Medium'">
              ALREADY HAS AN ACCOUNT
            </a>
          </el-row>

        </el-col>
      </el-row>
    </el-main>

  </el-container>
</template>

<script>

let bsd_logo =  require( '../../../src/assets/icons/earth.png');
import { api_bnu_getMailCode,api_bnu_register } from "@/api";

export default {
  name: "BNURegister",
  data(){
    return {
      logo:bsd_logo,
      loginData:{
        mail:undefined,
        password:undefined
      },
      registerIndex:0,
      registerParam:{
        mail:undefined,
        verifyCode:undefined,
        password:undefined,
        confirm_password:undefined
      }
    }
  },
  methods:{


    goHome(){
      this.$router.push({path:'/BNUMap/cc'})
    },
    switchToLogin(){
      console.log("SwitchToLogin");
      this.$router.push({path:'/BNUMap/Login'});
    },

    getMailVerifyCode(){
      if(this.registerParam.mail==undefined || this.registerParam.mail.length==0){
        this.$alert('Please Enter Email Address', 'Prompt', {
          confirmButtonText: 'OK',
          callback: action => {

          }
        });
        return;
      }
      console.log("get mail verify code button action");
      let _this = this;
      api_bnu_getMailCode({mail:this.registerParam.mail}).then(res=>{
        let resData = res.data;
        if(resData.code==200000){
          _this.registerIndex = 1;
        }else {
          this.$message.error(resData.msg);
        }
      })
    },

    /**
     * @description 第二步，提交注册
     * */
    submitRegisterRequest(){
      console.log("SubmitRegisterRequest");

      if(this.registerParam.verifyCode == undefined || this.registerParam.verifyCode.length==0){
        alert("Please enter the email verification code");
        this.$alert('Please enter the email verification code', 'Prompt', {
          confirmButtonText: 'OK'
        });
        return;
      }

      if(this.registerParam.password == undefined || this.registerParam.password.length==0){
        this.$alert('Please enter the password', 'Prompt', {
          confirmButtonText: 'OK'
        });
        return;
      }

      if(this.registerParam.confirm_password == undefined || this.registerParam.confirm_password.length==0){
        this.$alert('Please enter the confirm password', 'Prompt', {
          confirmButtonText: 'OK'
        });
        return;
      }

      if(this.registerParam.password != this.registerParam.confirm_password){
        this.$alert('The Two Passwords Do Not Match!', 'Prompt', {
          confirmButtonText: 'OK'
        });
        return;
      }

      let params = {
        mail:this.registerParam.mail,
        password: this.registerParam.password,
        verifyCode:this.registerParam.verifyCode
      };
      console.log("params = ",params);
      let _this = this;
      api_bnu_register(params).then(res=>{
        let resData = res.data;
        console.log("resData = ",resData);
        if(resData.code==200000){
          console.log("Register success && alert the prompt Dialog");
          _this.$alert(resData.msg, 'Prompt', {
            confirmButtonText: 'OK',
            callback: action => {
              console.log("Trigger the callback Dialog");
              _this.switchToLogin();
              console.log("Switch to the Login page");
            }
          });
        }else {
          _this.$message.error(resData.msg);
          _this.registerParam = {};
        }
      })

    }




  },

  mounted() {
    document.getElementById("router_view").style.height = document.body.clientHeight - 60 +"px";
    document.getElementById("form_container").style.height = document.body.clientHeight - 60 - 20 +"px";
  }
}
</script>




<style scoped lang="scss">
@import "BSDMap";

.BSD_TITLE{
  margin-top: 12px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}
.BSD_SUBTITLE{
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}

.rt_bg{
  background-image: linear-gradient(133deg, #042B64 0%, #040C21 53%, #06275F 87%, #451E49 100%);
}
.headerManu{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/BNURegister.vue